import {
    FINANCIAL_TYPE_LABELS,
    FinancialTypeFilter,
} from '@/lib/api/financial/financial-dashboard-api'
import { MdArrowDownward, MdArrowUpward, MdSwapVert } from 'react-icons/md'

interface FinancialTypeToggleProps {
    value: FinancialTypeFilter
    onChange: (value: FinancialTypeFilter) => void
}

const options: Array<{ value: FinancialTypeFilter; icon: typeof MdSwapVert }> = [
    { value: 'ALL', icon: MdSwapVert },
    { value: 'RECEIVABLE', icon: MdArrowDownward },
    { value: 'PAYABLE', icon: MdArrowUpward },
]

export default function FinancialTypeToggle({
    value,
    onChange,
}: FinancialTypeToggleProps) {
    return (
        <div className="join">
            {options.map(opt => {
                const Icon = opt.icon
                const active = opt.value === value
                return (
                    <button
                        key={opt.value}
                        onClick={() => onChange(opt.value)}
                        className={`btn btn-sm join-item ${
                            active ? 'btn-secondary' : 'btn-ghost border border-base-300'
                        }`}
                    >
                        <Icon className="text-base" />
                        {FINANCIAL_TYPE_LABELS[opt.value]}
                    </button>
                )
            })}
        </div>
    )
}
